import React from 'react';


const PrivacyPolicy = () => {
  return (
    <div className="privacyPolicy mb-5 pb-5">
      <h1>Privacy Policy</h1>
      <h3>Effective Date: 2024-11-08</h3>
      <p>
        At Rajamaa AB provided by Saxe IT, we respect your privacy and are
        committed to protecting the information you share with us. This
        Privacy Policy explains how we collect, use, and protect your
        information when you use our application.
      </p>
      <ol>
        <li>
          <strong>Information We Collect</strong>
          <p>
            We collect information that is necessary to provide you with the
            best booking experience. This includes:
          </p>
          <ul>
            <li>
              Session ID: Used to manage your shopping cart during your visit.
            </li>
            <li>
              Personal Information: For private users, we collect information
              such as your name, contact details, and booking history to
              better manage your reservations.
            </li>
            <li>
              Business User Information: For business users, we store company
              details and booking records to facilitate the management of
              bookings and provide customized services.
            </li>
          </ul>
        </li>
        <li>
          <strong>How We Use Your Information</strong>
          <p>
            Session ID: The session ID is used solely for maintaining your
            shopping cart during your visit.
          </p>
          <p>
            Personal and Business Information: We use this information to:
          </p>
          <ul>
            <li>Manage and track bookings.</li>
            <li>Provide customer support.</li>
            <li>
              Improve our services and ensure that your experience is
              seamless.
            </li>
            <li>
              Maintain records for legal, compliance, and administrative
              purposes.
            </li>
          </ul>
        </li>
        <li>
          <strong>Data Storage and Security</strong>
          <p>
            Your information is stored securely in our database, and we
            implement appropriate technical measures to protect it from
            unauthorized access, alteration, or deletion.
          </p>
          <p>
            Access to user information is limited to authorized personnel who
            need this data to perform their work.
          </p>
        </li>
        <li>
          <strong>Third-Party Services</strong>
          <p>
            We do not share your information with third-party services for
            advertising or tracking purposes.
          </p>
          <p>
            Any analytics used in our application are provided by Microsoft
            Azure, and Google Analytics, which helps us improve the performance of the app without
            tracking your individual browsing habits.
          </p>
        </li>
        <li>
          <strong>Your Rights</strong>
          <p>As a user, you have the right to:</p>
          <ul>
            <li>Access the information we hold about you.</li>
            <li>Request corrections to any inaccurate information.</li>
            <li>
              Request deletion of your personal data (subject to legal and
              administrative requirements).
            </li>
          </ul>
          <p>
            If you have any questions or wish to exercise your rights, please
            contact us at info@saxeit.se.
          </p>
        </li>
        <li>
          <strong>Changes to This Privacy Policy</strong>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or for other operational, legal, or
            regulatory reasons. We encourage you to review this policy
            periodically.
          </p>
        </li>
        <li>
          <strong>Contact Us</strong>
          <p>
            If you have any questions about this Privacy Policy or our data
            practices, please contact us at:
          </p>
          <p>Email: info@saxeit.com</p>
          <p>Phone: +46761179296</p>
          <p>Address: 1 Street, New York, 555-55 NY, US</p>
        </li>
      </ol>
      <p>
        Thank you for choosing Rajamaa AB. We appreciate your trust
        and are committed to protecting your privacy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
